module.exports = __webpack_public_path__ + "img/University-dashboard.2860ed24.png";